/**
 * Per-browser first-run flags (welcome card dismissed, tour seen, attention
 * summary dismissed) — read and written through ONE place so "View as" can
 * give them the target's answer instead of the operator's.
 *
 * Signed in as yourself these are plain localStorage flags, as before. Under a
 * View as lens the operator dismissed all of them long ago, so reading
 * localStorage would hide exactly the first-run experience an onboarding call
 * is trying to show. Under a lens they live in sessionStorage keyed by the
 * target instead: a fresh lens starts at "never seen", dismissing it sticks for
 * this tab, and the operator's own flags are never touched.
 */
export const WELCOME_DISMISSED_KEY = 'parkify_welcome_dismissed_v1'
export const WALKTHROUGH_SEEN_KEY = 'parkify_walkthrough_seen_v1'
export const ATTENTION_SUMMARY_DISMISSED_KEY = 'parkify_attention_summary_dismissed_v1'

function lensKey(key: string, lensEmail: string): string {
  return `${key}:viewas:${lensEmail.toLowerCase()}`
}

/** `ifUnreadable` is what to answer when storage throws (private mode). */
export function readFirstRunFlag(
  key: string, lensEmail: string | null | undefined, ifUnreadable = false,
): boolean {
  try {
    if (lensEmail) return sessionStorage.getItem(lensKey(key, lensEmail)) === 'true'
    return localStorage.getItem(key) === 'true'
  } catch {
    return ifUnreadable
  }
}

export function writeFirstRunFlag(key: string, lensEmail: string | null | undefined): void {
  try {
    if (lensEmail) sessionStorage.setItem(lensKey(key, lensEmail), 'true')
    else localStorage.setItem(key, 'true')
  } catch { /* private mode: non-fatal */ }
}
